import { useEffect, useState } from "react";
import CustomCarousel from "../custom-carousel/CustomCarousel";
import FilterModal_BS from "../filter-modal/FilterModal_BS";
import VideoModal_BS from "../video-modal/VideoModal_BS";
import {
  fetchVideosDataInDb,
  fetchClientsDataInDb,
} from "../../firebase/firebase";
import { useParams, useSearchParams } from "react-router-dom";

// const videoIds = [
//   "pkeDBwsIaZw",
//   "psuRGfAaju4",
//   "SYM-RJwSGQ8",
//   "MwpMEbgC7DA",
//   "qu577tNp1hA",
//   "TTAU7lLDZYU",
//   "gOU_zWdhAoE",
//   "ZwBkXgWNs_M",
//   "92XVwY54h5k",
//   "RSNmgE6L8AU",
//   "KY0TZQTwwbk",
//   "aFUzvbkEvRk",
//   "ff0oWESdmH0",
//   "eBG7P-K-r1Y",
// ];

// const videoIds = [
//   "2achTtMGVmk",
//   "EtCDy3KS0Zg",
//   "0Bk39yWHBvM",
//   "vNFskgfC6Fs",
//   "l-xVQ9bddmI",
//   "zS15g1jW09E",
//   "bBzAqKIDL64",
//   "dxuDaBrBm78",
// ];
// const videoIds = [
//   "1.jfif",
//   "2.jfif",
//   "3.jfif",
//   "4.jfif",
//   "5.jfif",
//   "6.jfif",
//   "7.jfif",
// ];

function Main() {
  const [videosData, setVideosData] = useState([]);
  const [clientsData, setClientsData] = useState([]);
  const [videoModalShow, setVideoModalShow] = useState(false);
  const [videoModalItem, setVideoModalItem] = useState(null);
  const [filterModalShow, setFilterModalShow] = useState(false);
  const [isLandscape, setIsLandscape] = useState(true);
  const [filter, setFilter] = useState(null);
  // let { filterId } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    async function fetchData() {
      try {
        // Fetch data from firebase
        let docData = await fetchVideosDataInDb();
        if (!docData.videos) return;
        setVideosData(docData.videos);

        let docData2 = await fetchClientsDataInDb();
        if (!docData2.clients) return;
        setClientsData(docData2.clients);
      } catch (err) {
        alert("Unable to fetch data from DB: " + err);
      }
    }
    fetchData();
  }, []);

  // useEffect(() => {
  //   if (filterId && filterId !== "null") {
  //     setFilter(filterId);
  //   }
  // }, [filterId]);

  useEffect(() => {
    if (searchParams) {
      let filterId = searchParams.get("filter");
      if (filterId && filterId !== null) {
        setFilter(filterId);
      }
    }
  }, [searchParams]);

  // useEffect(() => {
  //   let onResize = () => {
  //     // this.updateVideoContainerSize();
  //     // setTimeout(() => {
  //     //   this.updateVideoContainerSize();
  //     // }, 100);
  //     // setTimeout(() => {
  //     //   this.updateVideoContainerSize();
  //     // }, 250);
  //     console.log("resize", Screen.width);
  //   };

  //   window.addEventListener("resize", onResize);
  //   onResize();

  //   return () => {
  //     window.removeEventListener("resize", onResize);
  //   };
  // }, []);

  return (
    <>
      <CustomCarousel
        style={{
          overflowY: "hidden",
          width: "100vw",
          height: "100vh",
          marginLeft: "0rem",
          marginTop: "0rem",
          background: "black",
        }}
        onClick={(itemIndex) => {
          if (itemIndex == null) return;
          let filteredVideos = videosData.filter((videoData) =>
            // (videoData) => !filter || videoData.clientId === filter
            filter ? videoData.clientId === filter : videoData.sticky
          );
          if (filteredVideos.length > itemIndex) {
            setVideoModalItem(filteredVideos[itemIndex]);
            setVideoModalShow(true);
          }
        }}
        setIsLandscape={setIsLandscape}
        // clickedIndex={modalItemIndex}
      >
        {videosData
          // .filter((videoData) => !filter || videoData.company === filter)
          .filter((videoData) => filter ? videoData.clientId === filter : videoData.sticky)
          .map((videoData, index) => {
            return (
              // <div
              //   key={index}
              //   style={{
              //     width: "50vw",
              //     maxWidth: "50vw",
              //     marginLeft: `${50 * index}vw`,
              //     // marginBottom: index === videoIds.length - 1 ? "0" : "50vw",
              //   }}
              // >
              <div
                key={videoData.id}
                id={videoData.id}
                style={{
                  width: "100%",
                  height: "100%",
                  background: `url("${
                    isLandscape || videoData.useCrop
                      ? videoData.imageLandscape
                      : videoData.imagePortrait
                  }")`,
                  backgroundSize: "cover",
                  backgroundPositionX: videoData.useCrop
                    ? `${videoData.cropPosX}%`
                    : "center",
                  cursor: "pointer",
                  position: "relative",
                }}
                // onClick={() => {
                //   setModalItemIndex(videoData.videoId);
                //   // setModalShow(true);
                // }}
              >
                <div
                  style={{
                    color: "rgba(255,255,255,0.6)",
                    position: "absolute",
                    bottom: isLandscape ? "-2rem" : "0",
                    left: 0,
                    fontSize: isLandscape ? "1rem" : "1.25rem",
                    padding: isLandscape ? "0" : "0.25rem 1rem",
                    backgroundColor: "rgba(0,0,0,0.5)",
                  }}
                >
                  {videoData.title}
                </div>
              </div>
              // </div>
            );
          })}
      </CustomCarousel>

      <button
        type="button"
        style={{
          position: "absolute",
          top: "2.5rem",
          right: isLandscape ? "10%" : "1rem",
          backgroundColor: "rgba(255, 255, 255, 0.4)",
          color: "white",
          padding: "0.25rem 0.8rem",
          border: "none",
          outline: "none",
        }}
        onClick={() => {
          filter ? setFilter(null) : setFilterModalShow(true);
        }}
      >
        <span>
          <svg
            style={{
              display: "inline",
              marginRight: "0.5rem",
              verticalAlign: "baseline",
            }}
            width="20"
            height="13"
            viewBox="0 0 20 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="3.66667" cy="3.16667" r="2.66667" stroke="white" />
            <circle
              cx="3.16667"
              cy="3.16667"
              r="2.66667"
              transform="matrix(-1 0 0 1 19.5 6.33334)"
              stroke="white"
            />
            <line x1="8.1001" y1="3.3" x2="19.5001" y2="3.3" stroke="white" />
            <line
              y1="-0.5"
              x2="11.4"
              y2="-0.5"
              transform="matrix(-1 0 0 1 11.8999 10.1333)"
              stroke="white"
            />
          </svg>
        </span>
        <span>
          {isLandscape ? "Filter by Brand" : "Filter"}
          {filter ? <span>&nbsp;&times;</span> : null}
        </span>
      </button>

      <VideoModal_BS
        show={videoModalShow}
        onHide={() => setVideoModalShow(false)}
        videoId={videoModalItem && videoModalItem.videoId}
        title={videoModalItem && videoModalItem.title}
      />

      <FilterModal_BS
        clientsData={clientsData}
        show={filterModalShow}
        onHide={() => setFilterModalShow(false)}
        setFilter={setFilter}
      />

      {/* <div style={{ height: "50rem" }}></div> */}
    </>
  );
}

export default Main;
